import { Routes } from '@angular/router';

// Import all components used in routing
import { DTFHomeComponent } from './components/dtfhomepage/dtfhomepage.component';
import { OnlinepaymentComponent } from './components/olp/onlinepayment/onlinepayment.component';
import { GuestPayComponent } from './components/guest-pay/guestpay/guestpay.component';
import { ConnectedInsuranceComponent } from './components/connected-insurance/connected-insurance.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { HelppageComponent } from './components/olp/helppage/helppage.component';
import { PrinicipalpaymentComponent } from './components/olp/prinicpalpayment/prinicipalpayment.component';
import { RecurringpaymentComponent } from './components/olp/recurringpayment/recurringpayment.component';
import { StatementpaymentComponent } from './components/olp/statementpayment/statementpayment.component';
import { BankprofileComponent } from './components/olp/managebankprofile/bankprofile/bankprofile.component';
import { AddbankprofileComponent } from './components/olp/managebankprofile/addbankprofile/addbankprofile.component';
import { RemovebankprofileComponent } from './components/olp/managebankprofile/removebankprofile/removebankprofile.component';
import { EditbankprofileComponent } from './components/olp/managebankprofile/editbankprofile/editbankprofile.component';
import { CustomDatePickerComponent } from './components/sharing/custom-date-picker/custom-date-picker.component';
import { DTFCAHomeComponent } from './components/dtfcahomepage/dtfcahomepage.component';
import { DTFDashboardComponent } from './components/dashboard/dashboard.component';
import { ManageYourProfileComponent } from './manageYourProfile/manageYourProfile.component';
import { FawLoginComponent } from './components/fawlogin/fawlogin.component';
import { PaymenthistoryComponent } from './components/olp/paymenthistory/paymenthistory/paymenthistory.component';
import { DTFBrochuresComponent } from './components/brochures/brochures.component';
import { DTFInsuranceComponent } from './components/insurance/insurance.component';
import { ElectricFMVComponent } from './components/electricFMV/electricFMV.component';
import { DTFProgramsComponent } from './components/programs/programs.component';
import { LogoutComponent } from './components/logout/logout.component';
import { AccountdetailsComponent } from './components/accountdetails/accountdetails.component';
import { AmortizationComponent } from './components/amortization/amortization.component';
import { UseAndPrivacyComponent } from './components/useAndPrivacy/useAndPrivacy.component';
import { NewPrivacyComponent } from './components/newPrivacy/newPrivacy.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { PaymentOptionComponent } from './components/paymentOptions/paymentOption.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { DocumentCenterComponent } from './components/documentcenter/documentcenter.component';
import { DynamicLeaseComponent } from './components/dynamiclease/dynamiclease.component';
import { DynamicDashboardComponent } from './components/dynamicdashboard/dynamicdashboard.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminDashboardComponent } from './components/admindashboard/admindashboard.component';
import { AdminInvoiceComponent } from './components/admininvoice/admininvoice.component';
import { AdminMfaComponent } from './components/adminmfa/adminmfa.component';
import { AdminProfileComponent } from './adminprofile/adminprofile.component';
import { DynamicInsuranceComponent } from './components/dynamicinsurance/dynamicinsurance.component';
import { DynamicInsuranceFormComponent } from './components/dynamicinsuranceform/dynamicinsuranceform.component';
import { DynamicLeaseFormComponent } from './components/dynamicleaseform/dynamicleaseform.component';
import { PasswordResetComponent } from './components/passwordreset/passwordreset.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { DocRequestComponent } from './components/docrequest/docrequest.component';
import { TitleTransferComponent } from './components/titletransfer/titletransfer.component';
import { RegistrationPopupComponent } from './components/registrationPopup/registrationPopup.component';
import { RegistrationConfirmComponent } from './components/registrationConfirm/registrationConfirm.component';
import { PasswordResetConfirmComponent } from './components/passwordresetconfirm/passwordresetconfirm.component';
import { CCPAComponent } from './components/ccpa/ccpa.component';
import { AlertPageComponent } from './furniture/alert.component';
import { PayoffComponent } from './components/payoff/payoff.component';
import { PayComponent } from './components/pay/pay.component';
import { GlossaryComponent } from './components/glossary/glossary.component';
import { AboutUsComponent } from './components/aboutus/aboutus.component';
import { FinanceLeaseSolutionsComponent } from './components/financeleasesolutions/financeleasesolutions.component';
import { ContactUsComponent } from './components/contactus/contactus.component';
import { DealerLocatorComponent } from './components/dealerlocator/dealerlocator.component';
import { PaymentOptionsComponent } from './components/paymentoption/paymentoptions.component';
import { WebSupportTechReqs } from './components/websupporttechreqs/websupporttrechreqs.component';
import { FAQ } from './components/faq/faq.component';
import { AutoPayComponent } from './components/autoPay/autoPay.component';
import { VideoComponent } from './components/video/video.component';
import { FleetLayoutComponent } from './components/fleetservices/layout/fleetlayout.component';
import { FleetHomeComponent } from './components/fleetservices/fleethome.component';
import { FleetDashboardComponent } from './components/fleetservices/fleetdashboard.component';
import { MaintenanceComponent } from './components/errors/maintenance.component';
import { PageNotFoundComponent } from './components/errors/page-not-found.component';
import { InternalServerErrorComponent } from './components/errors/internal-server-error.component';

// Auth guards
import { AuthGuardService as AuthGuard } from './utils/auth-guard.service';
import { AdminAuthGuardService as AdminAuthGuard } from './utils/auth-guard.service';
import { ScheduledpaymentComponent } from './components/olp/scheduledpayment/scheduledpayment.component';
import { ConnectedInsuranceLeadComponent } from './components/connectedinsurancelead/connectedinsurancelead.component';
import { ConnectedInsuranceLeadFormComponent } from './components/connectedinsuranceleadform/connectedinsuranceleadform.component';
import { CarrerComponent } from './components/carrer/carrer.component';
import { ThankyouComponent } from './components/thankyou/thankyou.component';
import { DynamicLeaseFormcaComponent } from './components/dynamicleaseformca/dynamicleaseformca.component';
import { ThankyouGeicoComponent } from './components/thankyou-geico/thankyou-geico.component';
import { AdminFunctionsComponent } from './components/adminfunctions/adminfunctions.component';
import { SiteMapComponent } from './components/sitemap/sitemap.component';
import { incidentManagementComponent } from './components/incidentManagement/incidentManagement.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  // --- United States Routes ---
  { path: 'home', component: DTFHomeComponent },
  { path: 'home/onlinepayment', component: OnlinepaymentComponent, canActivate: [AuthGuard]},
  { path: 'home/scheduledpayment', component: ScheduledpaymentComponent, canActivate: [AuthGuard]},
  { path: 'home/guestpay', component: GuestPayComponent },
  { path: 'home/career', component: CarrerComponent },
  { path: 'home/thankyou', component: ThankyouComponent },
  { path: 'home/ConnectedInsurancethankyou', component: ThankyouGeicoComponent },
  { path: 'home/connected-insurance', component: ConnectedInsuranceLeadComponent },
  { path: 'home/connectedinsuranceleadform', component: ConnectedInsuranceLeadFormComponent },
  { path: 'home/unsubscribe', component: UnsubscribeComponent },
  { path: 'ca/en/home/unsubscribe', component: UnsubscribeComponent },
  { path: 'ca/fr/home/unsubscribe', component: UnsubscribeComponent },
  { path: 'home/help', component: HelppageComponent, canActivate: [AuthGuard] },
  { path: 'home/principalpayment', component: PrinicipalpaymentComponent,  canActivate: [AuthGuard] },
  { path: 'home/recurringpayment', component: RecurringpaymentComponent,  canActivate: [AuthGuard] },
  { path: 'home/statementpayment', component: StatementpaymentComponent,  canActivate: [AuthGuard] },
  { path: 'home/bankprofile', component: BankprofileComponent , canActivate: [AuthGuard]},
  { path: 'home/addprofile', component: AddbankprofileComponent ,  canActivate: [AuthGuard]},
  { path: 'home/removeprofile', component: RemovebankprofileComponent,  canActivate: [AuthGuard] },
  { path: 'home/editprofile', component: EditbankprofileComponent,  canActivate: [AuthGuard] },
  { path: 'home/customdatepicker', component: CustomDatePickerComponent },

  // --- Canada Root ---
  { path: 'ca/home', component: DTFCAHomeComponent },
  { path: 'cahome', component: DTFCAHomeComponent },
  { path: 'ca/en/home', component: DTFCAHomeComponent },
  { path: 'ca/fr/home', component: DTFCAHomeComponent },

  // --- Informational bilingual routes ---
  { path: 'ca/en/home/programs', component: DTFProgramsComponent },
  { path: 'ca/en/home/thankyou', component: ThankyouComponent },
  { path: 'ca/fr/home/thankyou', component: ThankyouComponent },
  { path: 'ca/fr/home/programs', component: DTFProgramsComponent },
  { path: 'ca/en/home/insurance', component: DTFInsuranceComponent },
  { path: 'ca/fr/home/insurance', component: DTFInsuranceComponent },
  { path: 'ca/en/home/electricFMV', component: ElectricFMVComponent },
  { path: 'ca/fr/home/electricFMV', component: ElectricFMVComponent },
  { path: 'ca/en/home/brochures', component: DTFBrochuresComponent },
  { path: 'ca/fr/home/brochures', component: DTFBrochuresComponent },
  { path: 'ca/en/home/aboutus', component: AboutUsComponent },
  { path: 'ca/fr/home/aboutus', component: AboutUsComponent },
  { path: 'ca/en/home/financeleasesolutions', component: FinanceLeaseSolutionsComponent },
  { path: 'ca/fr/home/financeleasesolutions', component: FinanceLeaseSolutionsComponent },
  { path: 'ca/en/home/contactus', component: ContactUsComponent },
  { path: 'ca/fr/home/contactus', component: ContactUsComponent },
  { path: 'ca/en/home/dealerlocator', component: DealerLocatorComponent },
  { path: 'ca/fr/home/dealerlocator', component: DealerLocatorComponent },
  { path: 'ca/en/home/websupporttechreqs', component: WebSupportTechReqs },
  { path: 'ca/fr/home/websupporttechreqs', component: WebSupportTechReqs },
  { path: 'ca/en/home/faq', component: FAQ },
  { path: 'ca/fr/home/faq', component: FAQ },
  { path: 'ca/en/home/video', component: VideoComponent },
  { path: 'ca/fr/home/video', component: VideoComponent },
  { path: 'ca/en/home/glossary', component: GlossaryComponent },
  { path: 'ca/fr/home/glossary', component: GlossaryComponent },
  { path: 'ca/en/home/useAndPrivacy', component: UseAndPrivacyComponent },
  { path: 'ca/fr/home/useAndPrivacy', component: UseAndPrivacyComponent },
  { path: 'ca/en/home/newPrivacy', component: NewPrivacyComponent },
  { path: 'ca/fr/home/newPrivacy', component: NewPrivacyComponent },
  { path: 'ca/en/home/calculator', component: CalculatorComponent },
  { path: 'ca/fr/home/calculator', component: CalculatorComponent },
  { path: 'ca/en/home/paymentOption', component: PaymentOptionComponent },
  { path: 'ca/fr/home/paymentOption', component: PaymentOptionComponent },
  { path: 'ca/en/home/paymentoptions', component: PaymentOptionsComponent },
  { path: 'ca/fr/home/paymentoptions', component: PaymentOptionsComponent },

  // --- Missing U.S. informational routes restored ---
  { path: 'home/programs', component: DTFProgramsComponent },
  { path: 'home/sitemap', component: SiteMapComponent },
  { path: 'home/insurance', component: DTFInsuranceComponent },
  { path: 'home/electricFMV', component: ElectricFMVComponent },
  { path: 'home/brochures', component: DTFBrochuresComponent },
  { path: 'home/aboutus', component: AboutUsComponent },
  { path: 'home/financeleasesolutions', component: FinanceLeaseSolutionsComponent },
  { path: 'home/contactus', component: ContactUsComponent },
  { path: 'home/dealerlocator', component: DealerLocatorComponent },
  { path: 'home/websupporttechreqs', component: WebSupportTechReqs },
  { path: 'home/faq', component: FAQ },
  { path: 'home/video', component: VideoComponent },
  { path: 'home/glossary', component: GlossaryComponent },
  { path: 'home/useAndPrivacy', component: UseAndPrivacyComponent },
  { path: 'home/newPrivacy', component: NewPrivacyComponent },
  { path: 'home/calculator', component: CalculatorComponent },
  { path: 'home/paymentOption', component: PaymentOptionComponent },
  { path: 'home/paymentoptions', component: PaymentOptionsComponent },

  // --- Guarded / Account-related / Admin / Fleet / Misc restored ---
  { path: 'home/dashboard', component: DTFDashboardComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/dashboard', component: DTFDashboardComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/dashboard', component: DTFDashboardComponent, canActivate: [AuthGuard] },
  { path: 'home/manageYourProfile', component: ManageYourProfileComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/manageYourProfile', component: ManageYourProfileComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/manageYourProfile', component: ManageYourProfileComponent, canActivate: [AuthGuard] },
  { path: 'home/agent/agentWebView', component: FawLoginComponent },
  { path: 'home/paymenthistory', component: PaymenthistoryComponent , canActivate: [AuthGuard]},
  { path: 'ca/en/home/paymenthistory', component: PaymenthistoryComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/paymenthistory', component: PaymenthistoryComponent, canActivate: [AuthGuard] },
  { path: 'home/accountdetails', component: AccountdetailsComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/accountdetails', component: AccountdetailsComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/accountdetails', component: AccountdetailsComponent, canActivate: [AuthGuard] },
  { path: 'home/amortization', component: AmortizationComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/amortization', component: AmortizationComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/amortization', component: AmortizationComponent, canActivate: [AuthGuard] },
  { path: 'home/invoice', component: InvoiceComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/invoice', component: InvoiceComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/invoice', component: InvoiceComponent, canActivate: [AuthGuard] },
  { path: 'home/documentcenter', component: DocumentCenterComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/documentcenter', component: DocumentCenterComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/documentcenter', component: DocumentCenterComponent, canActivate: [AuthGuard] },
  { path: 'home/payoff', component: PayoffComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/payoff', component: PayoffComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/payoff', component: PayoffComponent, canActivate: [AuthGuard] },
  { path: 'home/pay', component: PayComponent, canActivate: [AuthGuard] },
  { path: 'home/docrequest', component: DocRequestComponent, canActivate: [AuthGuard] },
  { path: 'ca/en/home/docrequest', component: DocRequestComponent, canActivate: [AuthGuard] },
  { path: 'ca/fr/home/docrequest', component: DocRequestComponent, canActivate: [AuthGuard] },
  { path: 'home/titletransfer', component: TitleTransferComponent, canActivate: [AuthGuard] },

  { path: 'home/dynamicdashboard', component: DynamicDashboardComponent },
  { path: 'home/dynamicinsurance', component: DynamicInsuranceComponent },
  { path: 'home/dynamicinsuranceform', component: DynamicInsuranceFormComponent },
  { path: 'home/dynamiclease', component: DynamicLeaseComponent },
  { path: 'ca/en/home/dynamiclease', component: DynamicLeaseComponent },
  { path: 'ca/fr/home/dynamiclease', component: DynamicLeaseComponent },
  { path: 'home/dynamicleaseform', component: DynamicLeaseFormComponent },
  { path: 'ca/en/home/dynamicleaseform', component: DynamicLeaseFormcaComponent },
  { path: 'ca/fr/home/dynamicleaseform', component: DynamicLeaseFormcaComponent },
  { path: 'home/dynamicfinancing', component: DynamicLeaseComponent },
  { path: 'ca/en/home/dynamicfinancing', component: DynamicLeaseComponent },
  { path: 'ca/fr/home/dynamicfinancing', component: DynamicLeaseComponent },
  
  { path: 'home/acm', component: AdminComponent },
  { path: 'home/admindashboard', component: AdminDashboardComponent, canActivate: [AdminAuthGuard]},
  { path: 'home/incidentManagement', component: incidentManagementComponent, canActivate: [AdminAuthGuard]},
  { path: 'home/admininvoice', component: AdminInvoiceComponent, canActivate: [AdminAuthGuard] },
  { path: 'home/adminmfa', component: AdminMfaComponent, canActivate: [AdminAuthGuard] },
  { path: 'home/adminfunctions', component: AdminFunctionsComponent, canActivate: [AdminAuthGuard] },
  { path: 'home/adminprofile', component: AdminProfileComponent, canActivate: [AdminAuthGuard] },

  { path: 'autopay', component: AutoPayComponent, canActivate: [AuthGuard] },
  { path: 'home/alertpage', component: AlertPageComponent },

  // --- Password, Registration, CCPA, Maintenance ---
  { path: 'home/passwordreset', component: PasswordResetComponent },
  { path: 'home/passwordresetconfirm', component: PasswordResetConfirmComponent },
  { path: 'home/registrationPopup', component: RegistrationPopupComponent },
  { path: 'home/registrationConfirm', component: RegistrationConfirmComponent },
  { path: 'home/ccpa', component: CCPAComponent },
  { path: 'home/maintenance', component: MaintenanceComponent },
  { path: 'ca/en/home/maintenance', component: MaintenanceComponent },
  { path: 'ca/fr/home/maintenance', component: MaintenanceComponent },

  // --- Fleet routes ---
  {
    path: 'home/fleet',
    component: FleetLayoutComponent,
    children: [
      { path: 'fleethome', component: FleetHomeComponent },
      { path: 'fleetdashboard', component: FleetDashboardComponent }
    ]
  },

  // --- Logout / Errors ---
  { path: 'logout', component: LogoutComponent },
  { path: 'ca/en/logout', component: LogoutComponent },
  { path: 'ca/fr/logout', component: LogoutComponent },
  { path: 'internal-server-error', component: InternalServerErrorComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent }
];
